/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Application API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseApplicationGroupConfigResponse,
  ApiResponseApplicationListItem,
  ApiResponseApplicationTargetsResponse,
  ApiResponseBoolean,
  ApiResponseClassMethodProfileResponse,
  ApiResponseClassSourceChangeResponse,
  ApiResponseClassSourceDiffResponse,
  ApiResponseDataSourceMetricResponse,
  ApiResponseGcAnalysisResponse,
  ApiResponseHeapDump,
  ApiResponseHeapDumpHistory,
  ApiResponseLibraryDao,
  ApiResponseLoadedClass,
  ApiResponseThreadDump,
  ApiResponseThreadDumpItem,
  ApiResponseTxnStatusResponse,
  ApiResponseWasDetailInfo,
  ApiResponseWasGcInfo,
  ClassProfilingRequest,
  ClassSourceResponse,
  GetV11ApplicationActiveTransactionsCountParams,
  GetV11ApplicationDatasourceMetricParams,
  GetV11ApplicationGcAnalysisReportParams,
  GetV11ApplicationLoadedClassByWasIdParams,
  GetV11ApplicationLoadedClassDiffByWasIdParams,
  GetV11ApplicationLoadedClassHistoryByWasIdParams,
  GetV11ApplicationLoadedClassMethodProfileByWasIdParams,
  GetV11ApplicationLoadedClassSourceByWasIdParams,
  GetV7ApplicationByWasIdParams,
  GetV7ApplicationHeapdumpByWasIdParams,
  GetV7ApplicationParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getActiveTxnStatusCount
 */
export const getV11ApplicationActiveTransactionsCount = (
  params?: MaybeRef<GetV11ApplicationActiveTransactionsCountParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseTxnStatusResponse>(
    {
      url: `/api/v11/application/active-transactions/count`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV11ApplicationActiveTransactionsCountQueryKey = (
  params?: MaybeRef<GetV11ApplicationActiveTransactionsCountParams>,
) => {
  return [
    'api',
    'v11',
    'application',
    'active-transactions',
    'count',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV11ApplicationActiveTransactionsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationActiveTransactionsCount>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11ApplicationActiveTransactionsCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationActiveTransactionsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationActiveTransactionsCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV11ApplicationActiveTransactionsCount>>
  > = ({ signal }) => getV11ApplicationActiveTransactionsCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationActiveTransactionsCount>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationActiveTransactionsCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationActiveTransactionsCount>>
>;
export type GetV11ApplicationActiveTransactionsCountQueryError = ErrorType<unknown>;

/**
 * @summary getActiveTxnStatusCount
 */

export function useGetV11ApplicationActiveTransactionsCount<
  TData = Awaited<ReturnType<typeof getV11ApplicationActiveTransactionsCount>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11ApplicationActiveTransactionsCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationActiveTransactionsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationActiveTransactionsCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getApplicationDataSourceMetric
 */
export const getV11ApplicationDatasourceMetric = (
  params: MaybeRef<GetV11ApplicationDatasourceMetricParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseDataSourceMetricResponse>(
    { url: `/api/v11/application/datasource/metric`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11ApplicationDatasourceMetricQueryKey = (
  params?: MaybeRef<GetV11ApplicationDatasourceMetricParams>,
) => {
  return [
    'api',
    'v11',
    'application',
    'datasource',
    'metric',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV11ApplicationDatasourceMetricQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationDatasourceMetric>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11ApplicationDatasourceMetricParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11ApplicationDatasourceMetric>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationDatasourceMetricQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11ApplicationDatasourceMetric>>> = ({
    signal,
  }) => getV11ApplicationDatasourceMetric(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationDatasourceMetric>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationDatasourceMetricQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationDatasourceMetric>>
>;
export type GetV11ApplicationDatasourceMetricQueryError = ErrorType<unknown>;

/**
 * @summary getApplicationDataSourceMetric
 */

export function useGetV11ApplicationDatasourceMetric<
  TData = Awaited<ReturnType<typeof getV11ApplicationDatasourceMetric>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11ApplicationDatasourceMetricParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11ApplicationDatasourceMetric>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationDatasourceMetricQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getApplicationGcAnalysisReport
 */
export const getV11ApplicationGcAnalysisReport = (
  params: MaybeRef<GetV11ApplicationGcAnalysisReportParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseGcAnalysisResponse>(
    {
      url: `/api/v11/application/gc-analysis-report`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV11ApplicationGcAnalysisReportQueryKey = (
  params?: MaybeRef<GetV11ApplicationGcAnalysisReportParams>,
) => {
  return ['api', 'v11', 'application', 'gc-analysis-report', ...(params ? [params] : [])] as const;
};

export const getGetV11ApplicationGcAnalysisReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationGcAnalysisReport>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11ApplicationGcAnalysisReportParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11ApplicationGcAnalysisReport>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationGcAnalysisReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11ApplicationGcAnalysisReport>>> = ({
    signal,
  }) => getV11ApplicationGcAnalysisReport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationGcAnalysisReport>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationGcAnalysisReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationGcAnalysisReport>>
>;
export type GetV11ApplicationGcAnalysisReportQueryError = ErrorType<unknown>;

/**
 * @summary getApplicationGcAnalysisReport
 */

export function useGetV11ApplicationGcAnalysisReport<
  TData = Awaited<ReturnType<typeof getV11ApplicationGcAnalysisReport>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11ApplicationGcAnalysisReportParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11ApplicationGcAnalysisReport>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationGcAnalysisReportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 어플리케이션 간략 목록 조회 (host 메트릭 포함)
 */
export const getV11ApplicationTargets = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseApplicationTargetsResponse>(
    { url: `/api/v11/application/targets`, method: 'GET', signal },
    options,
  );
};

export const getGetV11ApplicationTargetsQueryKey = () => {
  return ['api', 'v11', 'application', 'targets'] as const;
};

export const getGetV11ApplicationTargetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationTargets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV11ApplicationTargets>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationTargetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11ApplicationTargets>>> = ({
    signal,
  }) => getV11ApplicationTargets(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationTargets>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationTargetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationTargets>>
>;
export type GetV11ApplicationTargetsQueryError = ErrorType<unknown>;

/**
 * @summary 어플리케이션 간략 목록 조회 (host 메트릭 포함)
 */

export function useGetV11ApplicationTargets<
  TData = Awaited<ReturnType<typeof getV11ApplicationTargets>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11ApplicationTargets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationTargetsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 클래스 프로파일 설정/해제
 */
export const patchV11ApplicationClassProfilingByWasId = (
  wasId: MaybeRef<string>,
  classProfilingRequest: MaybeRef<ClassProfilingRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  wasId = unref(wasId);
  classProfilingRequest = unref(classProfilingRequest);

  return customAxiosInstance<ApiResponseBoolean>(
    {
      url: `/api/v11/application/${wasId}/class-profiling`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: classProfilingRequest,
    },
    options,
  );
};

export const getPatchV11ApplicationClassProfilingByWasIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV11ApplicationClassProfilingByWasId>>,
    TError,
    { wasId: string; data: BodyType<ClassProfilingRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV11ApplicationClassProfilingByWasId>>,
  TError,
  { wasId: string; data: BodyType<ClassProfilingRequest> },
  TContext
> => {
  const mutationKey = ['patchV11ApplicationClassProfilingByWasId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV11ApplicationClassProfilingByWasId>>,
    { wasId: string; data: BodyType<ClassProfilingRequest> }
  > = (props) => {
    const { wasId, data } = props ?? {};

    return patchV11ApplicationClassProfilingByWasId(wasId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV11ApplicationClassProfilingByWasIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV11ApplicationClassProfilingByWasId>>
>;
export type PatchV11ApplicationClassProfilingByWasIdMutationBody = BodyType<ClassProfilingRequest>;
export type PatchV11ApplicationClassProfilingByWasIdMutationError = ErrorType<unknown>;

/**
 * @summary 클래스 프로파일 설정/해제
 */
export const usePatchV11ApplicationClassProfilingByWasId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV11ApplicationClassProfilingByWasId>>,
      TError,
      { wasId: string; data: BodyType<ClassProfilingRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV11ApplicationClassProfilingByWasId>>,
  TError,
  { wasId: string; data: BodyType<ClassProfilingRequest> },
  TContext
> => {
  const mutationOptions = getPatchV11ApplicationClassProfilingByWasIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 로딩된 클래스 목록
 */
export const getV11ApplicationLoadedClassByWasId = (
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassByWasIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  params = unref(params);

  return customAxiosInstance<ApiResponseLoadedClass>(
    {
      url: `/api/v11/application/${wasId}/loaded-class`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV11ApplicationLoadedClassByWasIdQueryKey = (
  wasId?: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassByWasIdParams>,
) => {
  return ['api', 'v11', 'application', wasId, 'loaded-class', ...(params ? [params] : [])] as const;
};

export const getGetV11ApplicationLoadedClassByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationLoadedClassByWasIdQueryKey(wasId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11ApplicationLoadedClassByWasId>>> = ({
    signal,
  }) => getV11ApplicationLoadedClassByWasId(wasId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassByWasId>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationLoadedClassByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationLoadedClassByWasId>>
>;
export type GetV11ApplicationLoadedClassByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary 로딩된 클래스 목록
 */

export function useGetV11ApplicationLoadedClassByWasId<
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationLoadedClassByWasIdQueryOptions(wasId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 클래스 소스 비교
 */
export const getV11ApplicationLoadedClassDiffByWasId = (
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassDiffByWasIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  params = unref(params);

  return customAxiosInstance<ApiResponseClassSourceDiffResponse>(
    {
      url: `/api/v11/application/${wasId}/loaded-class/diff`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV11ApplicationLoadedClassDiffByWasIdQueryKey = (
  wasId?: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassDiffByWasIdParams>,
) => {
  return [
    'api',
    'v11',
    'application',
    wasId,
    'loaded-class',
    'diff',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV11ApplicationLoadedClassDiffByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassDiffByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassDiffByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassDiffByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationLoadedClassDiffByWasIdQueryKey(wasId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassDiffByWasId>>
  > = ({ signal }) =>
    getV11ApplicationLoadedClassDiffByWasId(wasId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassDiffByWasId>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationLoadedClassDiffByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationLoadedClassDiffByWasId>>
>;
export type GetV11ApplicationLoadedClassDiffByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary 클래스 소스 비교
 */

export function useGetV11ApplicationLoadedClassDiffByWasId<
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassDiffByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassDiffByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassDiffByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationLoadedClassDiffByWasIdQueryOptions(
    wasId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 클래스 변경 정보 이력
 */
export const getV11ApplicationLoadedClassHistoryByWasId = (
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassHistoryByWasIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  params = unref(params);

  return customAxiosInstance<ApiResponseClassSourceChangeResponse>(
    {
      url: `/api/v11/application/${wasId}/loaded-class/history`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV11ApplicationLoadedClassHistoryByWasIdQueryKey = (
  wasId?: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassHistoryByWasIdParams>,
) => {
  return [
    'api',
    'v11',
    'application',
    wasId,
    'loaded-class',
    'history',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV11ApplicationLoadedClassHistoryByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassHistoryByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassHistoryByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassHistoryByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationLoadedClassHistoryByWasIdQueryKey(wasId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassHistoryByWasId>>
  > = ({ signal }) =>
    getV11ApplicationLoadedClassHistoryByWasId(wasId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassHistoryByWasId>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationLoadedClassHistoryByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationLoadedClassHistoryByWasId>>
>;
export type GetV11ApplicationLoadedClassHistoryByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary 클래스 변경 정보 이력
 */

export function useGetV11ApplicationLoadedClassHistoryByWasId<
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassHistoryByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassHistoryByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassHistoryByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationLoadedClassHistoryByWasIdQueryOptions(
    wasId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 클래스 메서드 프로파일 (최근 1시간 집계)
 */
export const getV11ApplicationLoadedClassMethodProfileByWasId = (
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassMethodProfileByWasIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  params = unref(params);

  return customAxiosInstance<ApiResponseClassMethodProfileResponse>(
    {
      url: `/api/v11/application/${wasId}/loaded-class/method-profile`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV11ApplicationLoadedClassMethodProfileByWasIdQueryKey = (
  wasId?: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassMethodProfileByWasIdParams>,
) => {
  return [
    'api',
    'v11',
    'application',
    wasId,
    'loaded-class',
    'method-profile',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV11ApplicationLoadedClassMethodProfileByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassMethodProfileByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassMethodProfileByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassMethodProfileByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationLoadedClassMethodProfileByWasIdQueryKey(wasId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassMethodProfileByWasId>>
  > = ({ signal }) =>
    getV11ApplicationLoadedClassMethodProfileByWasId(wasId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassMethodProfileByWasId>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationLoadedClassMethodProfileByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationLoadedClassMethodProfileByWasId>>
>;
export type GetV11ApplicationLoadedClassMethodProfileByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary 클래스 메서드 프로파일 (최근 1시간 집계)
 */

export function useGetV11ApplicationLoadedClassMethodProfileByWasId<
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassMethodProfileByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassMethodProfileByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassMethodProfileByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationLoadedClassMethodProfileByWasIdQueryOptions(
    wasId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 클래스 소스 보기
 */
export const getV11ApplicationLoadedClassSourceByWasId = (
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassSourceByWasIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  params = unref(params);

  return customAxiosInstance<ClassSourceResponse>(
    {
      url: `/api/v11/application/${wasId}/loaded-class/source`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV11ApplicationLoadedClassSourceByWasIdQueryKey = (
  wasId?: MaybeRef<string>,
  params?: MaybeRef<GetV11ApplicationLoadedClassSourceByWasIdParams>,
) => {
  return [
    'api',
    'v11',
    'application',
    wasId,
    'loaded-class',
    'source',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV11ApplicationLoadedClassSourceByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassSourceByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassSourceByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassSourceByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11ApplicationLoadedClassSourceByWasIdQueryKey(wasId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassSourceByWasId>>
  > = ({ signal }) =>
    getV11ApplicationLoadedClassSourceByWasId(wasId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11ApplicationLoadedClassSourceByWasId>>,
    TError,
    TData
  >;
};

export type GetV11ApplicationLoadedClassSourceByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11ApplicationLoadedClassSourceByWasId>>
>;
export type GetV11ApplicationLoadedClassSourceByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary 클래스 소스 보기
 */

export function useGetV11ApplicationLoadedClassSourceByWasId<
  TData = Awaited<ReturnType<typeof getV11ApplicationLoadedClassSourceByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params: MaybeRef<GetV11ApplicationLoadedClassSourceByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11ApplicationLoadedClassSourceByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11ApplicationLoadedClassSourceByWasIdQueryOptions(
    wasId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 어플리케이션 목록 조회
 */
export const getV7Application = (
  params: MaybeRef<GetV7ApplicationParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseApplicationListItem>(
    { url: `/api/v7/application`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7ApplicationQueryKey = (params?: MaybeRef<GetV7ApplicationParams>) => {
  return ['api', 'v7', 'application', ...(params ? [params] : [])] as const;
};

export const getGetV7ApplicationQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7Application>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ApplicationParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Application>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7Application>>> = ({ signal }) =>
    getV7Application(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7Application>>,
    TError,
    TData
  >;
};

export type GetV7ApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof getV7Application>>>;
export type GetV7ApplicationQueryError = ErrorType<unknown>;

/**
 * @summary 어플리케이션 목록 조회
 */

export function useGetV7Application<
  TData = Awaited<ReturnType<typeof getV7Application>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ApplicationParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7Application>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 어플리케이션 디테일 정보
 */
export const getV7ApplicationByWasId = (
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationByWasIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  params = unref(params);

  return customAxiosInstance<ApiResponseWasDetailInfo>(
    { url: `/api/v7/application/${wasId}`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7ApplicationByWasIdQueryKey = (
  wasId?: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationByWasIdParams>,
) => {
  return ['api', 'v7', 'application', wasId, ...(params ? [params] : [])] as const;
};

export const getGetV7ApplicationByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationByWasIdQueryKey(wasId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ApplicationByWasId>>> = ({
    signal,
  }) => getV7ApplicationByWasId(wasId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationByWasId>>, TError, TData>;
};

export type GetV7ApplicationByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationByWasId>>
>;
export type GetV7ApplicationByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary 어플리케이션 디테일 정보
 */

export function useGetV7ApplicationByWasId<
  TData = Awaited<ReturnType<typeof getV7ApplicationByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationByWasIdQueryOptions(wasId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWasConfig
 */
export const getV7ApplicationConfigByWasId = (
  wasId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);

  return customAxiosInstance<ApiResponseApplicationGroupConfigResponse>(
    { url: `/api/v7/application/${wasId}/config`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ApplicationConfigByWasIdQueryKey = (wasId?: MaybeRef<string>) => {
  return ['api', 'v7', 'application', wasId, 'config'] as const;
};

export const getGetV7ApplicationConfigByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationConfigByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationConfigByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationConfigByWasIdQueryKey(wasId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ApplicationConfigByWasId>>> = ({
    signal,
  }) => getV7ApplicationConfigByWasId(wasId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationConfigByWasId>>, TError, TData>;
};

export type GetV7ApplicationConfigByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationConfigByWasId>>
>;
export type GetV7ApplicationConfigByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary getWasConfig
 */

export function useGetV7ApplicationConfigByWasId<
  TData = Awaited<ReturnType<typeof getV7ApplicationConfigByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationConfigByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationConfigByWasIdQueryOptions(wasId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 어플리케이션 GC 정보
 */
export const getV7ApplicationGarbageCollectionByWasId = (
  wasId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);

  return customAxiosInstance<ApiResponseWasGcInfo>(
    { url: `/api/v7/application/${wasId}/garbage-collection`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ApplicationGarbageCollectionByWasIdQueryKey = (wasId?: MaybeRef<string>) => {
  return ['api', 'v7', 'application', wasId, 'garbage-collection'] as const;
};

export const getGetV7ApplicationGarbageCollectionByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationGarbageCollectionByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationGarbageCollectionByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationGarbageCollectionByWasIdQueryKey(wasId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ApplicationGarbageCollectionByWasId>>
  > = ({ signal }) => getV7ApplicationGarbageCollectionByWasId(wasId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ApplicationGarbageCollectionByWasId>>,
    TError,
    TData
  >;
};

export type GetV7ApplicationGarbageCollectionByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationGarbageCollectionByWasId>>
>;
export type GetV7ApplicationGarbageCollectionByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary 어플리케이션 GC 정보
 */

export function useGetV7ApplicationGarbageCollectionByWasId<
  TData = Awaited<ReturnType<typeof getV7ApplicationGarbageCollectionByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationGarbageCollectionByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationGarbageCollectionByWasIdQueryOptions(wasId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getHeapDump
 */
export const getV7ApplicationHeapdumpByWasId = (
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationHeapdumpByWasIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  params = unref(params);

  return customAxiosInstance<ApiResponseHeapDump>(
    { url: `/api/v7/application/${wasId}/heapdump`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7ApplicationHeapdumpByWasIdQueryKey = (
  wasId?: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationHeapdumpByWasIdParams>,
) => {
  return ['api', 'v7', 'application', wasId, 'heapdump', ...(params ? [params] : [])] as const;
};

export const getGetV7ApplicationHeapdumpByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationHeapdumpByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationHeapdumpByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationHeapdumpByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationHeapdumpByWasIdQueryKey(wasId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ApplicationHeapdumpByWasId>>> = ({
    signal,
  }) => getV7ApplicationHeapdumpByWasId(wasId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationHeapdumpByWasId>>, TError, TData>;
};

export type GetV7ApplicationHeapdumpByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationHeapdumpByWasId>>
>;
export type GetV7ApplicationHeapdumpByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary getHeapDump
 */

export function useGetV7ApplicationHeapdumpByWasId<
  TData = Awaited<ReturnType<typeof getV7ApplicationHeapdumpByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  params?: MaybeRef<GetV7ApplicationHeapdumpByWasIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationHeapdumpByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationHeapdumpByWasIdQueryOptions(wasId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getHeapDumpHistory
 */
export const getV7ApplicationHeapdumpHistoryByWasId = (
  wasId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);

  return customAxiosInstance<ApiResponseHeapDumpHistory>(
    { url: `/api/v7/application/${wasId}/heapdump/history`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ApplicationHeapdumpHistoryByWasIdQueryKey = (wasId?: MaybeRef<string>) => {
  return ['api', 'v7', 'application', wasId, 'heapdump', 'history'] as const;
};

export const getGetV7ApplicationHeapdumpHistoryByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationHeapdumpHistoryByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationHeapdumpHistoryByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationHeapdumpHistoryByWasIdQueryKey(wasId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ApplicationHeapdumpHistoryByWasId>>
  > = ({ signal }) => getV7ApplicationHeapdumpHistoryByWasId(wasId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ApplicationHeapdumpHistoryByWasId>>,
    TError,
    TData
  >;
};

export type GetV7ApplicationHeapdumpHistoryByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationHeapdumpHistoryByWasId>>
>;
export type GetV7ApplicationHeapdumpHistoryByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary getHeapDumpHistory
 */

export function useGetV7ApplicationHeapdumpHistoryByWasId<
  TData = Awaited<ReturnType<typeof getV7ApplicationHeapdumpHistoryByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationHeapdumpHistoryByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationHeapdumpHistoryByWasIdQueryOptions(wasId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWasLibraries
 */
export const getV7ApplicationLibrariesByWasId = (
  wasId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);

  return customAxiosInstance<ApiResponseLibraryDao>(
    { url: `/api/v7/application/${wasId}/libraries`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ApplicationLibrariesByWasIdQueryKey = (wasId?: MaybeRef<string>) => {
  return ['api', 'v7', 'application', wasId, 'libraries'] as const;
};

export const getGetV7ApplicationLibrariesByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationLibrariesByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationLibrariesByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationLibrariesByWasIdQueryKey(wasId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ApplicationLibrariesByWasId>>> = ({
    signal,
  }) => getV7ApplicationLibrariesByWasId(wasId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationLibrariesByWasId>>, TError, TData>;
};

export type GetV7ApplicationLibrariesByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationLibrariesByWasId>>
>;
export type GetV7ApplicationLibrariesByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary getWasLibraries
 */

export function useGetV7ApplicationLibrariesByWasId<
  TData = Awaited<ReturnType<typeof getV7ApplicationLibrariesByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ApplicationLibrariesByWasId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationLibrariesByWasIdQueryOptions(wasId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWasThreadDumps
 */
export const getV7ApplicationThreadDumpListByWasId = (
  wasId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);

  return customAxiosInstance<ApiResponseThreadDump>(
    { url: `/api/v7/application/${wasId}/threadDumpList`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ApplicationThreadDumpListByWasIdQueryKey = (wasId?: MaybeRef<string>) => {
  return ['api', 'v7', 'application', wasId, 'threadDumpList'] as const;
};

export const getGetV7ApplicationThreadDumpListByWasIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationThreadDumpListByWasIdQueryKey(wasId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasId>>
  > = ({ signal }) => getV7ApplicationThreadDumpListByWasId(wasId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(wasId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasId>>,
    TError,
    TData
  >;
};

export type GetV7ApplicationThreadDumpListByWasIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasId>>
>;
export type GetV7ApplicationThreadDumpListByWasIdQueryError = ErrorType<unknown>;

/**
 * @summary getWasThreadDumps
 */

export function useGetV7ApplicationThreadDumpListByWasId<
  TData = Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationThreadDumpListByWasIdQueryOptions(wasId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getWasThreadDumpDetail
 */
export const getV7ApplicationThreadDumpListByWasIdAndThreadId = (
  wasId: MaybeRef<string>,
  threadId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  wasId = unref(wasId);
  threadId = unref(threadId);

  return customAxiosInstance<ApiResponseThreadDumpItem>(
    { url: `/api/v7/application/${wasId}/threadDumpList/${threadId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ApplicationThreadDumpListByWasIdAndThreadIdQueryKey = (
  wasId?: MaybeRef<string>,
  threadId?: MaybeRef<number>,
) => {
  return ['api', 'v7', 'application', wasId, 'threadDumpList', threadId] as const;
};

export const getGetV7ApplicationThreadDumpListByWasIdAndThreadIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasIdAndThreadId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  threadId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasIdAndThreadId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ApplicationThreadDumpListByWasIdAndThreadIdQueryKey(wasId, threadId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasIdAndThreadId>>
  > = ({ signal }) =>
    getV7ApplicationThreadDumpListByWasIdAndThreadId(wasId, threadId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(wasId) && unref(threadId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasIdAndThreadId>>,
    TError,
    TData
  >;
};

export type GetV7ApplicationThreadDumpListByWasIdAndThreadIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasIdAndThreadId>>
>;
export type GetV7ApplicationThreadDumpListByWasIdAndThreadIdQueryError = ErrorType<unknown>;

/**
 * @summary getWasThreadDumpDetail
 */

export function useGetV7ApplicationThreadDumpListByWasIdAndThreadId<
  TData = Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasIdAndThreadId>>,
  TError = ErrorType<unknown>,
>(
  wasId: MaybeRef<string>,
  threadId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ApplicationThreadDumpListByWasIdAndThreadId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ApplicationThreadDumpListByWasIdAndThreadIdQueryOptions(
    wasId,
    threadId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
